module.exports = "<navigation user=\"$ctrl.currentUser\" logout-url=\"'/login'\" show-logout='true'></navigation>\n\n<div ui-view></div>\n<toaster-container aria-live=\"polite\" aria-relevant=\"additions\" toaster-options=\"{'position-class': 'toast-bottom-full-width', 'time-out':10000}\"></toaster-container>\n<div id=\"loading-overlay\" ng-if=\"$ctrl.loading\">\n    <i class=\"fa fa-spin fa-circle-o-notch\"></i>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/client/app/shared/widget/layout/layout.html
// module id = 421
// module chunks = 0